/* eslint-disable no-undef */
/* eslint-disable no-useless-catch */
import { ENV } from "../utils";

/**
 * AI Assistant service for Gemini Flash integration
 * Handles communication with the backend AI endpoint
 */
export class AiAssistant {
  baseApi = ENV.BASE_API;

  /**
   * Send a message to the Gemini Flash AI assistant
   * @param {string} accessToken - JWT access token for authentication
   * @param {Object} payload - Message payload
   * @param {string} payload.userMessage - The user's message/question (required)
   * @param {Array} [payload.tasks] - Student's pending tasks (optional)
   * @param {Array} [payload.classes] - Student's classes information (optional)
   * @param {Array} [payload.exams] - Student's exams information (optional)
   * @param {Object} [payload.progress] - Student's academic progress (optional)
   * @param {Object} [payload.preferences] - Student's preferences (optional)
   * @param {string} [payload.instructions] - Additional instructions for the AI (optional)
   * @param {Object} [payload.metadata] - Additional metadata (app, studentId, etc.)
   * @returns {Promise<Object>} Response with summary, steps, suggestions, text, and meta
   * @throws {Error} Throws error with specific status codes: 400 (invalid), 429 (rate limit), 502/503 (service unavailable), 500 (server error)
   */
  async sendMessage(accessToken, payload) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.AI_CHAT}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
        },
        body: JSON.stringify(payload),
      };
      const response = await fetch(url, params);
      let result;

      try {
        result = await response.json();
      } catch (parseError) {
        result = {};
      }

      if (!response.ok) {
        // Extract error message with priority order
        const errorMessage =
          typeof result?.message === "string"
            ? result.message
            : typeof result?.error === "string"
            ? result.error
            : result?.error?.message ||
              "No se pudo obtener respuesta del asistente.";
        
        // Create error with status code for better handling in UI
        const error = new Error(errorMessage);
        error.status = response.status;
        throw error;
      }

      return result;
    } catch (error) {
      throw error;
    }
  }
}
